import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Translate from '@client/components/shared/translation/Translate';

import { CancelIcon } from '../../shared/SvgIcons';

import styles from './popover.scss';

export function Popover({ position, title, content, closePopover }) {
    return (
        <div styleName={`wrapper-${position}`}>
            <div styleName={`arrow-${position}`}></div>
            <a onClick={closePopover} styleName="close-tooltip">
                <CancelIcon styleName="icon" />
            </a>
            <h3 styleName="title">
                <Translate message={title} />
            </h3>
            <div styleName="content">
                <Translate message={content} />
            </div>
        </div>
    );
}

Popover.propTypes = {
    position: PropTypes.string.isRequired,
    closePopover: PropTypes.func,
    title: PropTypes.string,
    content: PropTypes.string
};

export default CSSModules(Popover, styles, { allowMultiple: true });
